export default __webpack_public_path__ + "static/media/explore.e8e370d0.png";